export enum Routes {
    HOME = '/',
}